import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  initResultIndexReport,
  setResultIndexReport,
  setErrors
} from "redux/modules/resultIndexReport";

// Component
import ResultIndexReport from "components/ReportDetail/ResultIndexReport";
// Utils
import history from "utils/history";

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  initResultIndexReport: () => {
    dispatch(initResultIndexReport());
  },
  fetchResultIndexReport: () => {
    const { id } = ownProps.match.params;

    const params = new URLSearchParams(window.location.search);
    const attrItem = params.get('attr_item_id');
    if (attrItem) {
      api
        .get(`result_index_report/${id}`, { attr_item_id: attrItem })
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setResultIndexReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    } else {
      api
        .get(`result_index_report/${id}`)
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setResultIndexReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ResultIndexReport);



// WEBPACK FOOTER //
// ./src/containers/ReportDetail/ResultIndexReportContainer.js